define('orderStatusTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('orderstatus.details.tabTitle')
    }
  ];
});
